// eslint-disable-next-line import/no-cycle
// import router from '@/app/router';

// eslint-disable-next-line import/no-cycle
import router from '@/app/router';

export default function isAuth({ next, store }) {
	if (!store.state.token) {
		return router.push({
			path: '/login',
			query: Object.fromEntries(new URLSearchParams(window.location.search)),
		});
	}
	return next();
}
